import React from 'react';

const Miscelanea = () => (
  <div className="miscelanea" />
);

export default Miscelanea;
